/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { ComponentType, lazy } from 'react'
import { UserRole } from '../shared/Auth2.0/AuthStoreState'
import { useAuth } from '../shared/Auth2.0/useAuth'

// Corregir el import del Login
const Login = lazy(() => import('../Login').then(({ Login }) => ({ default: Login })))

const DEV_MODE = window.env.VITE_ENABLE_DEV_MODE === true

export interface MCPRoute {
  title: string
  path: string
    component?: React.LazyExoticComponent<ComponentType<any>> | ComponentType<any> // Updated type
  disabled?: boolean
  defaultOpen?: boolean
  exact?: boolean
  hideInSidebar?: boolean
  childRoutes?: MCPRoute[]
  authorizedRoles?: UserRole[]
}

export const useRoutes = () => {
  const { user } = useAuth()

  const globalRoutes: MCPRoute[] = [
    {
      title: 'login',
      path: '/',
      component: Login,
      exact: true,
      hideInSidebar: true,
      authorizedRoles: [UserRole.USER, UserRole.APPROVER, UserRole.MAINTAINER],
    }
  ]

  const filterDisabledItems = (items: MCPRoute[]) => {
    return items
      .filter(route => !route.disabled)
      .filter(route => {
        if (route.authorizedRoles === undefined) {
          return true
        }

        return user?.roles.some(role => route.authorizedRoles?.includes(role))
      })
      .map(y => {
        if (y.childRoutes) {
          y.childRoutes = filterDisabledItems(y.childRoutes)
        }
        return y
      })
  }

  const routes = filterDisabledItems(globalRoutes)
  return { routes }
}
